import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';

import { setTemplateItem, useTemplate } from '../../store/TemplateContext';
import { usePayment, sendAnswers } from '../../store/PaymentContext';
import { IChallengeItem, recacheCvv, tokenizeCard } from '../../helpers/fetch-service';

import { redirectToDecline, redirectToSuccess } from '../../helpers/parent-helper';
import { useNavigate, useLocation } from 'react-router-dom';
import { TemplateBuilder } from '../../helpers/TemplateBuilder';
import { useCommon } from '../../store/CommonContext';
import { getSearchParameter } from '../../helpers/location-helper';
import * as Sentry from '@sentry/react';
import { logger, loggerError } from '../../helpers/logger';
import { findItem } from '../../helpers/form-helper';
import { checkIfPlaidTemplate, checkIfSpreedly_3DS, checkIfTokenex_3DS } from '../../helpers/challenge-helper';

import './ChallengeForm.css';
import { toAbsoluteUrl } from '../../helpers/AssetHelpers';

// FIXME fix any
interface Props {
  template: IChallengeItem[];
  initialValues: { [key: string]: string };
  spreedlyInitialValues: { [key: string]: string };
  validationSchema: any;
  spreedlyValidationSchema: any;
  isCard?: boolean;
}

const ChallengeForm: React.FC<Props> = props => {
  const {
    state: { configuration, challengeTemplate },
    dispatch: commonDispatch,
  } = useCommon();
  const { template, initialValues, validationSchema, spreedlyValidationSchema, spreedlyInitialValues, isCard } = props;
  const mid = getSearchParameter('mid');
  const navigate = useNavigate();
  const location = useLocation();
  const {
    state: { templateItem, parameters },
    dispatch,
  } = useTemplate();
  const {
    dispatch: paymentDispatch,
    state: { paymentLoading },
  } = usePayment();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const checkSpreedlyTemplate = (template: IChallengeItem[]): IChallengeItem | undefined => {
    let temp;
    template.forEach(el => {
      if (el.children) {
        const item = checkSpreedlyTemplate(el.children);
        if (item) {
          temp = item;
        }
      }
      if (el.inputType === 'CreditCard' || el.inputType === 'Cvv') {
        temp = el;
      }
    });

    return temp;
  };

  useEffect(() => {
    // const input = document.getElementById()
    // const input = document.querySelectorAll('#ui-widget-input-card-mask');
    // input.forEach(el => {
    //   const formattedCreditCardInput = new CreditCardInputMask({
    //     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //     // @ts-ignore
    //     element: el,
    //     pattern: '{{9999}} {{9999}} {{9999}} {{999999}}',
    //   });
    // });
  }, [template]);

  useEffect(() => {
    const item = checkSpreedlyTemplate(template);
    if (item && item?.dataId !== templateItem?.dataId) {
      setTemplateItem(dispatch, item);
    }
  }, [template]);

  const formik = useFormik<any>({
    initialValues,
    validationSchema,
    onSubmit: () => void 0,
    enableReinitialize: true,
  });

  const spreedlyFormik = useFormik<any>({
    initialValues: spreedlyInitialValues,
    validationSchema: spreedlyValidationSchema,
    onSubmit: values => {
      if (parameters.PaymentInstrumentToken) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        Spreedly?.recache();
      } else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        Spreedly?.validate(values);
        // Spreedly.tokenizeCreditCard(answers);
      }
    },
  });

  const handleClick = (e: any): void => {
    if (e.target.id === 'ui-widget-openbanking-button') {
      console.log('showPlaid__001');
      // eslint-disable-next-line no-restricted-globals
      parent.postMessage(
        {
          message: 'showPlaid',
          value: challengeTemplate?.parameters?.OpenBankingField,
          plaidLinkedToken: challengeTemplate?.parameters?.PlaidLinkedToken,
        },
        '*',
      );
      return;
    }

    if (
      e.target.className?.includes('ui-widget-list-button') ||
      e.target.id === 'ui-widget-success-button' ||
      e.target.id === 'ui-widget-challenge-button' ||
      e.target.id === 'ui-widget-ok-button' ||
      e.target.id === 'ui-widget-openbanking-button'
    ) {
      setIsButtonDisabled(true);
    }

    if (e.target.id === 'ui-widget-success-button' && checkIfPlaidTemplate(challengeTemplate?.challenge)) {
      console.log('showPlaid__002');
      // eslint-disable-next-line no-restricted-globals
      parent.postMessage(
        {
          message: 'showPlaid',
          value: challengeTemplate?.parameters?.OpenBankingField,
          plaidLinkedToken: challengeTemplate?.parameters?.PlaidLinkedToken,
        },
        '*',
      );
      navigate({
        pathname: '/loader',
        search: location?.search,
      });
      return;
    }

    const spreedlyTemplate = checkIfSpreedly_3DS(challengeTemplate?.challenge);
    if (e.target.id === 'ui-widget-success-button' && spreedlyTemplate?.dataId) {
      // eslint-disable-next-line no-restricted-globals
      parent.postMessage(
        {
          message: 'showSpreedly_3DS',
          token: challengeTemplate?.parameters?.Token,
          dataId: spreedlyTemplate?.dataId,
        },
        '*',
      );
      return;
    }

    const tokenex_3DSTemplate = checkIfTokenex_3DS(challengeTemplate?.challenge);
    if (e.target.id === 'ui-widget-success-button' && tokenex_3DSTemplate?.dataId) {
      // eslint-disable-next-line no-restricted-globals
      navigate({
        pathname: '/tokenex-3ds',
        search: location?.search,
      });
      return;
    }

    if (
      e.target.id === 'ui-widget-challenge-button' ||
      e.target.id === 'ui-widget-close-button' ||
      e.target.className?.includes('ui-widget-list-button')
    ) {
      if (challengeTemplate?.parameters?.Redirect === 'Approve') {
        redirectToSuccess();
        return;
      }

      if (challengeTemplate?.parameters?.Redirect === 'Decline') {
        redirectToDecline(navigate);
        return;
      }

      sendAnswers({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        answers: { [e.target.getAttribute('dataid')]: true },
        dispatch: paymentDispatch,
        navigate,
        location,
        configuration,
        commonDispatch,
        templateDispatch: dispatch,
      });
      return;
    }

    // if (e.target.id === 'ui-widget-success-button' || e.target.id === 'ui-widget-challenge-button') {
    //   formik.handleSubmit(e);
    // }

    if (e.target.id === 'ui-widget-success-button') {
      formik.handleSubmit(e);
      if (!templateItem && parameters.CureType !== 'NewCard') {
        formik.validateForm().then(data => {
          if (Object.keys(data).length === 0 && !paymentLoading) {
            sendAnswers({
              answers: formik.values,
              dispatch: paymentDispatch,
              navigate,
              location,
              configuration,
              commonDispatch,
              templateDispatch: dispatch,
            });
          } else {
            setIsButtonDisabled(false);
          }
        });
      }

      if (templateItem?.inputType === 'CreditCard') {
        Sentry.setTag('cure', 'CreditCard');
        spreedlyFormik.submitForm();
      }

      if (parameters.CureType === 'NewCard') {
        Sentry.setTag('cure', 'CreditCard');
        formik.validateForm().then(data => {
          if (Object.keys(data).length === 0 && !paymentLoading) {
            const month = findItem('month', template);
            const year = findItem('year', template);
            if (month && year) {
              const creditCard = {
                ...formik.values,
                month: month.potentialAnswers.find(el => el.id === formik.values.month)?.text,
                year: year.potentialAnswers.find(el => el.id === formik.values.year)?.text,
              };

              if (challengeTemplate?.parameters?.FirstName && !formik.values.firstName) {
                creditCard.firstName = challengeTemplate?.parameters?.FirstName;
              }

              if (challengeTemplate?.parameters?.LastName && !formik.values.flastName) {
                creditCard.lastName = challengeTemplate?.parameters?.LastName;
              }

              if (!parameters.TokenField) {
                logger({ name: 'TokenField is empty', message: 'TokenField is empty' });
                return redirectToDecline(navigate);
              }

              const transaction = Sentry.startTransaction({ name: 'POST_recache_cvv' });
              const span = transaction.startChild({
                op: 'http',
                description: `POST challenge`,
              });

              tokenizeCard({
                environment: configuration.tokenizationPublicKey,
                mid: mid || '',
                creditCard,
              })
                .then(res => {
                  span.setData('GET tokenize card response', JSON.stringify(res));
                  span.finish();

                  if (
                    (Array.isArray(res?.errors) && res?.errors?.length > 0) ||
                    Object.keys(res?.errors || {}).length > 0
                  ) {
                    logger({ name: 'POST tokenize card error', message: JSON.stringify(res.errors) });
                    const answers = { [parameters.TokenField || '']: null };
                    sendAnswers({
                      answers,
                      dispatch: paymentDispatch,
                      navigate,
                      location,
                      configuration,
                      commonDispatch,
                      templateDispatch: dispatch,
                    });
                  } else {
                    const token = res?.transaction?.payment_method?.token;
                    const answers = { [parameters.TokenField as string]: token };

                    if (parameters.FirstNameField && formik.values.firstName) {
                      answers[parameters.FirstNameField] = formik.values.firstName;
                    }

                    if (parameters.LastNameField && formik.values.lastName) {
                      answers[parameters.LastNameField] = formik.values.lastName;
                    }
                    sendAnswers({
                      answers,
                      dispatch: paymentDispatch,
                      navigate,
                      location,
                      configuration,
                      commonDispatch,
                      templateDispatch: dispatch,
                    });
                  }
                })
                .catch(error => {
                  Sentry.captureMessage('WidgetShell: POST tokenizeCard error', error.message);
                  logger({ name: 'WidgetShell: POST tokenizeCard error', message: error.message });

                  span.setData('WidgetShell: POST tokenizeCard error', error.messages);
                  span.finish();
                  transaction.finish();

                  loggerError(error);
                  // redirectToDecline();
                  const answers = { [parameters.TokenField || '']: null };
                  sendAnswers({
                    answers,
                    dispatch: paymentDispatch,
                    navigate,
                    location,
                    configuration,
                    commonDispatch,
                    templateDispatch: dispatch,
                  });
                });
            } else {
              return redirectToDecline(navigate);
            }
          }
        });
      }

      if (templateItem?.inputType === 'Cvv') {
        Sentry.setTag('cure', 'CVV');
        if (!parameters.PaymentInstrumentToken || !configuration?.tokenizationPublicKey) {
          logger({
            name: 'Missing TokenizationPublicKey or PaymentInstrumentToken',
            message: {
              PaymentInstrumentToken: parameters.PaymentInstrumentToken,
              TokenizationPublicKey: configuration?.tokenizationPublicKey,
            },
          });
        }
        formik.validateForm().then(data => {
          if (Object.keys(data).length === 0 && !paymentLoading) {
            const transaction = Sentry.startTransaction({ name: 'POST_recache_cvv' });
            const span = transaction.startChild({
              op: 'http',
              description: `POST challenge`,
            });

            recacheCvv({
              cvv: formik.values[templateItem?.dataId || ''],
              PaymentInstrumentToken: parameters.PaymentInstrumentToken as string,
              environment: configuration.tokenizationPublicKey,
              mid: mid || '',
            })
              .then(res => {
                span.setData('GET challenge response', JSON.stringify(res));
                span.finish();
                transaction.finish();

                if (
                  (Array.isArray(res?.errors) && res?.errors?.length > 0) ||
                  Object.keys(res?.errors || {}).length > 0
                ) {
                  logger({ name: 'POST recache error', message: JSON.stringify(res.errors) });
                  const answers = { ...formik.values, [templateItem?.dataId || '']: null };
                  sendAnswers({
                    answers,
                    dispatch: paymentDispatch,
                    navigate,
                    location,
                    configuration,
                    commonDispatch,
                    templateDispatch: dispatch,
                  });
                } else {
                  const token = res?.message?.id ? res?.message?.id : res?.transaction?.payment_method?.token;
                  const answers = { ...formik.values, [templateItem?.dataId || '']: token };
                  sendAnswers({
                    answers,
                    dispatch: paymentDispatch,
                    navigate,
                    location,
                    configuration,
                    commonDispatch,
                    templateDispatch: dispatch,
                  });
                }
              })
              .catch(error => {
                Sentry.captureMessage('WidgetShell: POST recache cvv error', error.message);
                logger({ name: 'WidgetShell: POST recache cvv error', message: error.message });

                span.setData('POST recache cvv error', error.messages);
                span.finish();
                transaction.finish();

                loggerError(error);
                // redirectToDecline();
                const answers = { ...formik.values, [templateItem?.dataId || '']: null };
                sendAnswers({
                  answers,
                  dispatch: paymentDispatch,
                  navigate,
                  location,
                  configuration,
                  commonDispatch,
                  templateDispatch: dispatch,
                });
              });
          } else {
            setIsButtonDisabled(false);
          }
        });
      }
    }
  };

  const inputChangeCallback = (): void => {
    setIsButtonDisabled(false);
  };

  return (
    <form className="ui-widget-challenge-form" onClick={handleClick}>
      {/*<img alt="Logo" className="links-logo" src={toAbsoluteUrl('/flex-logo-small.svg')} />*/}
      <TemplateBuilder
        template={template}
        isFormGroup={false}
        values={initialValues.values}
        formik={formik}
        spreedlyFormik={spreedlyFormik}
        isCard={isCard}
        isButtonDisabled={isButtonDisabled}
        inputChangeCallback={inputChangeCallback}
      />
    </form>
  );
};

export default ChallengeForm;
